<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.editCity") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Name Inputs -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city_name_ar')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city_name_en')"
            v-model.trim="data.name_en"
            required
          />
          <!-- End:: Name Inputs -->

          <!-- Start:: Status Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Status Switch Input -->

          <!-- End:: Map Section -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EditCity",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        name_ar: null,
        name_en: null,
        is_active: true,
      },
      // End:: Data Collection To Send

      // Start:: Map Data
      mapCenter: { lat: 24.7136, lng: 46.6753 }, // Riyadh coordinates
      cityPoints: [],
      polygonOptions: {
        strokeColor: '#FF6B35',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF6B35',
        fillOpacity: 0.35,
        editable: false,
      },
      // End:: Map Data
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // Start:: Map Methods
    addPoint(event) {
      const point = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      this.cityPoints.push(point);
    },

    removePoint(index) {
      this.cityPoints.splice(index, 1);
    },

    clearAllPoints() {
      this.cityPoints = [];
    },
    // End:: Map Methods

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      
      // Start:: Append Request Data
      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      REQUEST_DATA.append("_method", "PUT");
      REQUEST_DATA.append("is_active", this.data.is_active ? 1 : 0);
      
      // Append city points
      // this.cityPoints.forEach((point, index) => {
      //   REQUEST_DATA.append(`points[${index}][lat]`, point.lat);
      //   REQUEST_DATA.append(`points[${index}][lng]`, point.lng);
      // });

      try {
        await this.$axios({
          method: "POST",
          url: `cities/${this.$route.params?.id}?_method=put`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/cities/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: Show Data
    async showCity() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `cities/${this.$route.params?.id}`,
        });
        
        const cityData = res.data.data?.City;
        this.data.name_ar = cityData.name_ar;
        this.data.name_en = cityData.name_en;
        this.data.is_active = cityData.is_active;

        // Load city points if available
        // if (cityData.points && cityData.points.length > 0) {
        //   this.cityPoints = cityData.points.map(point => ({
        //     lat: parseFloat(point.lat),
        //     lng: parseFloat(point.lng)
        //   }));
        //   if (this.cityPoints.length > 0) {
        //     const avgLat = this.cityPoints.reduce((sum, point) => sum + point.lat, 0) / this.cityPoints.length;
        //     const avgLng = this.cityPoints.reduce((sum, point) => sum + point.lng, 0) / this.cityPoints.length;
        //     this.mapCenter = { lat: avgLat, lng: avgLng };
        //   }
        // }
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },
    // End:: Show Data
  },

  created() {
    this.showCity();
  },
};
</script>

<style lang="scss" scoped>
.map_section_wrapper {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;

  h5 {
    color: #333;
    margin-bottom: 10px;
  }

  .map_container {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .points_info {
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 6px;
    
    span {
      font-weight: 500;
      color: #495057;
    }
    
    small {
      font-size: 12px;
      line-height: 1.4;
    }
  }
}
</style>
